<template>
  <div>
    <div>
      <pie-chart
        :library="chartOptions"
        :data="gender"
        :colors="colors"
        :legend="true"
        height="300px"
        width="100%"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import AdminClient from '@/api/AdminClient';
import genderOptions from '@/helpers/mixins/gender-options';

Vue.use(Chartkick.use(Chart));
export default {
    name: 'CounselorByGender',
    mixins: [genderOptions],
    data() {
      return {
        adminClient: new AdminClient(this.$http),
        selected: '',
        chartOptions: {
          legend: { display: true, labels: { fontColor: '#f5f5f5' } },
        },
        colors: [
        '#4cf2f0',
        '#77e9b8',
        '#9de093',
        '#c0d476',
        '#e0c567',
        '#e49b4d',
        '#e16e47',
        '#dc564b',
        '#d43d51'
        ]
      }
    },
    asyncComputed:{
      async counselorByGender() {
        const response = await this.adminClient.getCounselorGender();
        if (!response || !response.results) return {}
        return response.results
      }
    },
    computed: {
      gender() {
        if (!this.counselorByGender) return {};
        const genderList = this.counselorByGender[0];
        const {
          unknown,
          prefer_not_to_say,
          none,
          ...rest
        } = genderList;
        const displayGenders = {}
        Object.keys(rest).forEach(key => {
          const label = this.getCounselorGenderDisplayName(key);
          displayGenders[label] = rest[key];
        })
        return displayGenders;
      }
    },
}
</script>
